import { render, staticRenderFns } from "./favoriteItem.vue?vue&type=template&id=3bb034d6&scoped=true"
import script from "./favoriteItem.vue?vue&type=script&lang=js"
export * from "./favoriteItem.vue?vue&type=script&lang=js"
import style0 from "./favoriteItem.vue?vue&type=style&index=0&id=3bb034d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb034d6",
  null
  
)

export default component.exports